var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDetectLocation = function SvgDetectLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 1.988a.6.6 0 0 1 .6.6v2.25A7.186 7.186 0 0 1 19.16 11.4h2.251a.6.6 0 0 1 0 1.2h-2.25A7.185 7.185 0 0 1 12.6 19.16v2.252a.6.6 0 0 1-1.2 0v-2.252A7.185 7.185 0 0 1 4.84 12.6H2.587a.6.6 0 0 1 0-1.2H4.84a7.186 7.186 0 0 1 6.562-6.562v-2.25a.6.6 0 0 1 .6-.6m0 4.024-.008-.001a5.99 5.99 0 1 0 .015 0z"
  })));
};
export default SvgDetectLocation;